const VALID_SHOW_HINTS = ["QS", "DEV"];

export function getShowHint() {
  const showHint = window.RUNTIME_CONFIG?.showHint ?? process.env.REACT_APP_SHOW_HINT;
  return VALID_SHOW_HINTS.includes(showHint) ? showHint : undefined;
}

export function isSectionLibraryEnabled() {
  const enabled = window.RUNTIME_CONFIG?.sectionLibraryEnabled ?? process.env.REACT_APP_SECTION_LIBRARY_ENABLED;
  return enabled === true || enabled === "true";
}

export function isSurveyValidationEnabled() {
  const enabled = window.RUNTIME_CONFIG?.surveyValidationEnabled ?? process.env.REACT_APP_SURVEY_VALIDATION_ENABLED;
  return enabled === true || enabled === "true";
}
